/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Observation } from "./Observation";
import {
  ObservationFromJSON,
  ObservationFromJSONTyped,
  ObservationToJSON,
  ObservationToJSONTyped,
} from "./Observation";

/**
 *
 * @export
 * @interface ApiGldObservationsList200Response
 */
export interface ApiGldObservationsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGldObservationsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGldObservationsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGldObservationsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<Observation>}
   * @memberof ApiGldObservationsList200Response
   */
  results: Array<Observation>;
}

/**
 * Check if a given object implements the ApiGldObservationsList200Response interface.
 */
export function instanceOfApiGldObservationsList200Response(
  value: object
): value is ApiGldObservationsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGldObservationsList200ResponseFromJSON(
  json: any
): ApiGldObservationsList200Response {
  return ApiGldObservationsList200ResponseFromJSONTyped(json, false);
}

export function ApiGldObservationsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGldObservationsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(ObservationFromJSON),
  };
}

export function ApiGldObservationsList200ResponseToJSON(
  json: any
): ApiGldObservationsList200Response {
  return ApiGldObservationsList200ResponseToJSONTyped(json, false);
}

export function ApiGldObservationsList200ResponseToJSONTyped(
  value?: ApiGldObservationsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(ObservationToJSON),
  };
}
